import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FileSpreadsheet, FileText, Loader2 } from "lucide-react";

const PreviewTable = ({ headers, rows, testId }) => (
  <table className="w-full text-xs" data-testid={testId}>
    <thead className="sticky top-0 bg-slate-900 text-white">
      <tr>{headers.map((h) => <th key={h} className="text-left font-semibold px-3 py-2 whitespace-nowrap">{h}</th>)}</tr>
    </thead>
    <tbody>
      {rows.length === 0 && (
        <tr><td colSpan={headers.length} className="text-center py-10 text-slate-500" data-testid={`${testId}-empty`}>Kayıt bulunamadı.</td></tr>
      )}
      {rows.map((r, i) => (
        <tr key={i} className={`border-t border-slate-100 ${/TOPLAM/.test(r[0]) ? "font-semibold bg-slate-50" : i % 2 ? "bg-slate-50/50" : ""}`}>
          {r.map((c, j) => <td key={j} className="px-3 py-1.5 align-top">{c}</td>)}
        </tr>
      ))}
    </tbody>
  </table>
);

const Sections = ({ sections }) => (
  <div className="divide-y divide-slate-200" data-testid="report-preview-sections">
    {sections.map((s, i) => (
      <section key={s.heading} className="py-3" data-testid={`report-preview-section-${i}`}>
        <h4 className="px-3 pb-2 font-display font-semibold text-slate-900 text-sm">
          {s.heading}{s.total !== undefined && <span className="ml-2 text-xs font-normal text-slate-500">({s.total} kayıt{s.total > s.rows.length ? `, ilk ${s.rows.length} gösteriliyor` : ""})</span>}
        </h4>
        <PreviewTable headers={s.headers} rows={s.rows} testId={`report-preview-section-table-${i}`} />
      </section>
    ))}
  </div>
);

const countText = (d) => d.sections
  ? `${d.sections.length} bölüm · toplam ${d.total} kayıt`
  : `${d.total} satır${d.total > d.rows.length ? ` · ilk ${d.rows.length} satır gösteriliyor` : ""}`;

export const ReportPreviewDialog = ({ preview, onClose, onDownload }) => (
  <Dialog open={!!preview} onOpenChange={(o) => { if (!o) onClose(); }}>
    <DialogContent className="max-w-6xl w-[95vw] max-h-[90vh] flex flex-col" data-testid="report-preview-dialog">
      <DialogHeader>
        <DialogTitle className="pr-8" data-testid="report-preview-title">{preview?.data?.title || "Rapor önizlemesi"}</DialogTitle>
        <DialogDescription data-testid="report-preview-count">
          {preview?.loading ? "Hazırlanıyor..." : preview?.data ? countText(preview.data) : ""}
        </DialogDescription>
      </DialogHeader>
      <div className="flex-1 min-h-0 overflow-auto border border-slate-200 rounded-md">
        {preview?.loading ? (
          <div className="flex items-center justify-center py-16 text-slate-500"><Loader2 className="h-5 w-5 animate-spin mr-2" /> Yükleniyor...</div>
        ) : preview?.data && (preview.data.sections
          ? <Sections sections={preview.data.sections} />
          : <PreviewTable headers={preview.data.headers} rows={preview.data.rows} testId="report-preview-table" />)}
      </div>
      <div className="flex justify-end gap-2 pt-2">
        <Button variant="outline" size="sm" onClick={() => onDownload(preview.type, "pdf")} disabled={!preview?.data} data-testid="report-preview-pdf">
          <FileText className="h-3.5 w-3.5 mr-1.5 text-rose-600" /> PDF İndir
        </Button>
        <Button variant="outline" size="sm" onClick={() => onDownload(preview.type, "excel")} disabled={!preview?.data} data-testid="report-preview-excel">
          <FileSpreadsheet className="h-3.5 w-3.5 mr-1.5 text-emerald-600" /> Excel İndir
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
